export default __webpack_public_path__ + "static/3-8f7b0609a1a48e29c3fb6fe4b48c6291.webp";